import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { isMobileOnly, MobileOnlyView } from 'react-device-detect'

const EscuelaGracias = () => {
    const location = useLocation()
    const userName = location.state?.userName || '' 
  return (
    <div>
      <div className={isMobileOnly ? 'display-none' : 'inscription-backgound'}>
        <div className="info-hero">
          <div className="inscription-block">
            <div className={isMobileOnly ? 'display-none' : 'sub-school-menu'}>
              <div className="items">
                <h5 className="item-school-selected">INSCRIPCIÓN</h5>
                <Link to="/escuela/info">
                  <h5 className="item-school">VOLVER</h5>
                </Link>
              </div>
              <div>
                <Link to="/" className="school-home-link">
                  <h5>HOME</h5>
                </Link>
              </div>
            </div>
            <div className="inscription-title">
              <h2>Gracias {userName && `${userName}`} por inscribirte!</h2>
              <p>
                El día anterior al inicio del curso recibirás un mail con el link para acceder.
              </p>
            </div>
          </div>
        </div>
        <div class="push" />
      </div>
      <MobileOnlyView>
        <section className="info-backgound">
          <div className="inscription-school-mobile-box">
            <div className="logo-school-box-mobile">
              <img src="/img/LogoEscuelaAFZ.png" alt="Escuela de Caución AFZ" />
            </div>

            <div className="thanks-message">
              <h2>Gracias {userName && `${userName}`} por inscribirte!</h2>
              <p>
            El día anterior al inicio del curso recibirás un mail con el link para acceder.
              </p>
              <div className="final-buttons-box">
                <Link to="/escuela/info">
                  <h5 className="home-mobile-footer">VOLVER</h5>
                </Link>
                <Link to="/">
                  <h5 className="home-mobile-footer">HOME</h5>
                </Link>
              </div>
            </div>
          </div>
          <div class="push-thanks" />
        </section>
      </MobileOnlyView>
    </div>
  )
}
export default EscuelaGracias
